import { allGames, GameConfig } from '@/config/game';

export function getGameById(id: string | number): GameConfig | undefined {
  return allGames.find((g) => g.id === +id);
}
